import {Quiz} from '@/services/Quiz'
import {getCurrentQuiz, getRandomPastQuiz} from '@/services/BrApiAdapter'

// import {config} from '@/services/config'
// let urlParams = new URLSearchParams (window.location.search)
// console.log (`checking parameter cat: ${urlParams.has('cat')}: - ${urlParams.get('cat')}`)
// console.log (JSON.stringify(config));
// console.log (config[config.SERVER].baseUrl);

// let currPath = config[config.SERVER].baseUrl + (urlParams.has('cat') && urlParams.get('cat').length ? `/${urlParams.get('cat')}` : '') + '/current';
// let randPath = config[config.SERVER].baseUrl + (urlParams.has('cat') && urlParams.get('cat').length ? `/${urlParams.get('cat')}` : '') + '/random';

export default {
  async initCurrentQuiz() {
    let quizResponse = await getCurrentQuiz()
    this.quizState = new Quiz(quizResponse.quiz_data, quizResponse.title)
    return this.quizState
  },
  async initRandomPastQuiz() {
    let quizResponse = await getRandomPastQuiz()
    this.quizState = new Quiz(quizResponse.quiz_data, quizResponse.title)
    return this.quizState
  },
  quizState: {} as Quiz
}